// @todo figure out how to load a different config for a different environment

const AppConfig = {
	baseUrl: '/'
};

export default AppConfig;
